export enum FeatureFlag {
  DualRolesPortal = "kp.dualRolesPortal",
  EmbargoedAssets = "kp.embargoed-assets",
  LaunchpadModuleIcon = "kp.launchpad-module-icon",
  ACCArchiveColumns = "kp.auv.archive-columns",
  GCNotificationSettings = "kp.eun.notification-settings",
  GCOrderIntakeEeg = "kp.eun.order-intake-eeg-chart",
  GCRejectionRate = "kp.eun.rejection-rate-badge",
  GCChartConsumption = "kp.chart-consumption",
  OMPointsOfContact = "kp.om.points-of-contact",
  OMPointsOfContactDelete = "kp.om.points-of-contact-delete",
  OMExcavationLayer = "kp.om.excavation-layer",
  OMExcavationNotification = "kp.om.excavation-notification",
  OMTroubleTickerNotifications = "kp.om.trouble-ticker-notifications",
  TYPMeasuresHistory = "kp.3yp.measures-history",
  OMVirtualBuildings = "kp.om.virtual-buildings",
  ConfigAreaCreateMunicipality = "kp.config-area.create-municipality",
  NEuSAutoStartNetzeBwScenario = "kp.neus.auto-start-netze-bw-scenario"
}
